// src/components/setting/SortableProductItem.js
import React from 'react';
import {
  useSortable,
} from '@dnd-kit/sortable';
import {
  CSS,
} from '@dnd-kit/utilities';
import styles from './ProductManager.module.css';

const SortableProductItem = ({ product, onToggleVisibility, sortMode }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: product.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1000 : 1,
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div 
      ref={setNodeRef}
      style={style}
      className={`${styles.productRow} ${product.isHidden ? styles.productRowHidden : ''} ${
        sortMode ? styles.productRowSortable : ''
      } ${isDragging ? styles.productRowDragging : ''}`}
      {...attributes}
      {...listeners}
    >
      <div className={styles.colName}>
        <div className={styles.productInfo}>
          {sortMode && (
            <div className={styles.dragHandle}>
              <span className={styles.dragIcon}>⋮⋮</span>
            </div>
          )}
          <div className={styles.productImageThumb}>
            <img 
              src={product.image || "/api/placeholder/60/60"} 
              alt={product.name}
              className={styles.thumbImage}
            />
          </div>
          <div className={styles.productNameWrapper}>
            <span className={styles.productName}>{product.name}</span>
            {product.description && (
              <span className={styles.productDesc}>
                {product.description.length > 30 
                  ? `${product.description.substring(0, 30)}...` 
                  : product.description}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={styles.colType}>
        {product.type || '未分類'}
      </div>
      <div className={styles.colActions}>
        <div className={styles.actionButtons}>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onToggleVisibility(product, e);
            }}
            className={product.isHidden ? styles.showButton : styles.hideButton}
            title={product.isHidden ? '表示する' : '非表示にする'}
          >
            {product.isHidden ? '👁' : '🚫'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortableProductItem;